import React from 'react';
import Css from './Shapes.module.css';

function Shapes() {
    return (
        <div className={Css.content}>
            <div className={Css.shapes}></div>
        </div>

    );
}

export default Shapes;